import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET004_Request,
  IAPI_RET004_Response,
  IAPI_RET005_Request,
  IAPI_RET005_Response,
} from "../../../type/apiType";
import {
  IAPI_COM014_Request,
  IAPI_COM014_Response,
} from "../../../type/apiType";

// 退職手当金請求参照
const httpAPI_RET004 = async (
  param: IAPI_RET004_Request
): Promise<IAPI_RET004_Response> => {
  let res = await http.post(ApiUrl.API_RET004, {
    ...param,
  });
  return res.data;
};

// 退職手当金請求更新
const httpAPI_RET005 = async (
  param: IAPI_RET005_Request
): Promise<IAPI_RET005_Response> => {
  let res = await http.post(ApiUrl.API_RET005, {
    ...param,
  });
  return res.data;
};

// ファイルダウンロード
const httpAPI_COM014 = async (
  param: IAPI_COM014_Request
): Promise<IAPI_COM014_Response> => {
  let res = await http.post(ApiUrl.API_COM014, {
    ...param,
  });
  return res.data;
};

export { httpAPI_RET005, httpAPI_RET004 ,httpAPI_COM014 };
